// src/Components/ErrorPages/Error500.jsx
import { useNavigate } from 'react-router-dom';
import './ErrorPages.css';

const Error500 = () => {
  const navigate = useNavigate();
  return (
    <div className="errorContainer">
      <span className="errorCodigo">500</span>
      <h2 className="errorTitulo">Error del servidor</h2>
      <p className="errorMensaje">
        Algo salió mal de nuestro lado. Intentá nuevamente en unos minutos.
      </p>
      <button onClick={() => navigate('/')} className="errorBtn">
        Volver al inicio
      </button>
    </div>
  );
};

export default Error500;
